export enum Trips {
  ROUND_TRIP = "roundTrip",
  ONE_WAY_START = "oneWayStart",
  ONE_WAY_END = "oneWayEnd",
}
